import React from 'react';
import { fileUrl } from '@/lib/api';

export default function MaintenancePage({ maintenance = {} }) {
  const eyebrow = maintenance.eyebrow || 'SEICON III';
  const headline = maintenance.headline || 'Coming Soon';
  const body = maintenance.body || 'We are preparing something extraordinary. Please check back shortly.';
  const bg = fileUrl(maintenance.image_url);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-bg-canvas relative overflow-hidden"
      data-testid="maintenance-page"
      style={bg ? { backgroundImage: `linear-gradient(rgba(244,239,231,0.85), rgba(244,239,231,0.92)), url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center' } : undefined}
    >
      <div className="container-x text-center py-24 max-w-3xl">
        <p className="eyebrow mb-6" data-testid="maintenance-eyebrow">{eyebrow}</p>
        <h1 className="font-display font-bold uppercase text-ink-primary leading-[0.95] text-[48px] md:text-[80px] lg:text-[112px] tracking-tightish" data-testid="maintenance-headline">
          {headline}
        </h1>
        <p className="mt-8 font-body text-ink-muted text-base md:text-lg max-w-xl mx-auto" data-testid="maintenance-body">{body}</p>
      </div>
    </div>
  );
}
